import {
    initialize,
    trackEvent,
    setUserId,
    removeUserId,
    setUserProperties,
    setEmail,
    setPhoneNumber,
    setTimezone,
    getUserId,
    getUserProperties,
    requestPermission,
    setSdkType,
    setSdkVersion,
    setSource,
    getSdkVersion,
} from './Client';

const notifly = {
    initialize,
    trackEvent,
    setUserId,
    removeUserId,
    setUserProperties,
    setEmail,
    setPhoneNumber,
    setTimezone,
    getUserId,
    getUserProperties,
    requestPermission,
    setSdkType,
    setSdkVersion,
    setSource,
    getSdkVersion,
};

export default notifly;
